import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../../../../common/FormBase';
import Form from './Form';
import { MakeFields } from './validation/fields';
import { makeInitialState } from '../../../../../helpers/FormHelper';
import { schema } from './validation/schema';

const ChangeEmail = ({ ...props }) => {
  const { mobile, motiveId, typeId } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        issueForm
        mobile={mobile}
        title=""
        buttonTitle="Enviar solicitud"
        fields={MakeFields()}
        data={data}
        formName="changeEmail"
        schema={schema}
        makeInitialState={makeInitialState}
        onState={onState}
        onValid={handleValid}
        motiveId={motiveId}
        typeId={typeId}
        form={
          <Form
            state={state}
            onData={handleData}
            valid={valid}
            mobile={mobile}
            motiveId={motiveId}
            fields={MakeFields()}
          />
        }
      />
    </React.Fragment>
  );
};

ChangeEmail.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  typeId: PropTypes.string,
};

export default ChangeEmail;
